
import { Form } from 'vee-validate';
import { computed, defineComponent, ref } from 'vue';
import AppButton from '@/components/UI/AppButton.vue';
import { CREATE_STEPS } from '@/types/enums';

export default defineComponent({
  components: {
    Form,
    AppButton,
  },
  props: {
    dataLoading: { type: Boolean, default: false },
  },
  setup(props, context) {
    const inputData = ref('Private');

    const publicData = ref(false);

    const closePublicData = computed(() => {
      if (inputData.value === 'Secret' || inputData.value === 'Private') {
        return false;
      }
      return true;
    });

    function changePublicData() {
      if (inputData.value !== 'PUBLIC_OPEN' && inputData.value !== 'PUBLIC_MANAGE') {
        publicData.value = true;
        inputData.value = 'PUBLIC_OPEN';
      }
    }

    function nextStep() {
      context.emit('on-set-step', { value: inputData.value, step: CREATE_STEPS.ADD });
    }

    return {
      inputData,
      nextStep,
      publicData,
      changePublicData,
      closePublicData,
    };
  },
});
